export const QuoteCviIcon = (props: { class?: string }) => {
    return (
        <svg
            class={props.class}
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path d="M18.0561 6C16.9927 10.1869 16.0623 14.7726 15.2648 19.757C14.5337 24.7414 14.1018 29.46 13.9688 33.9128H4V30.9221C4 26.6687 4.76428 22.3821 6.29283 18.0623C7.88785 13.676 9.81516 9.65524 12.0748 6H18.0561ZM36 6C34.9367 10.1869 34.0062 14.7726 33.2087 19.757C32.4777 24.7414 32.0457 29.46 31.9128 33.9128H21.9439V30.9221C21.9439 26.6687 22.7082 22.3821 24.2368 18.0623C25.8318 13.676 27.7591 9.65524 30.0187 6H36Z" />
        </svg>
    );
};
